export const GET_COURTS_REQUEST = "GET_COURTS_REQUEST";
export const GET_COURTS_SUCCESS = "GET_COURTS_SUCCESS";
export const GET_COURTS_FAIL = "GET_COURTS_FAIL";
export const GET_COURTS_RESET = "GET_COURTS_RESET";